import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import { useEffect, useState, useRef, useCallback } from 'react';

var useObserver = function useObserver(ref, callback) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var externalState = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var Observer = useRef(null);
  var onIntersect = useCallback(callback, [ref].concat(_toConsumableArray(externalState)));
  useEffect(function () {
    if (!ref) return;
    if (Observer.current) Observer.current.unobserve(ref);
    Observer.current = new IntersectionObserver(onIntersect, options);
    var currentObserver = Observer.current;
    currentObserver.observe(ref);
    return function () {
      return currentObserver.unobserve(ref);
    };
  }, [ref].concat(_toConsumableArray(externalState)));
  return Observer.current;
};

export var useInViewEffect = function useInViewEffect(callback) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var externalState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      ref = _useState2[0],
      setRef = _useState2[1];

  useObserver(ref, callback, options, externalState);
  return setRef;
};
export var useInView = function useInView(options) {
  var externalState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var ops = __rest(options, []);

  var _ops$root = ops.root,
      root = _ops$root === void 0 ? null : _ops$root,
      _ops$rootMargin = ops.rootMargin,
      rootMargin = _ops$rootMargin === void 0 ? '0px 0px 0px 0px' : _ops$rootMargin,
      _ops$threshold = ops.threshold,
      threshold = _ops$threshold === void 0 ? 0 : _ops$threshold,
      target = ops.target,
      onEnter = ops.onEnter,
      onLeave = ops.onLeave,
      unobserveOnEnter = ops.unobserveOnEnter;

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      ref = _useState4[0],
      setRef = _useState4[1];

  var _useState5 = useState({
    isIntersecting: false,
    entry: null
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      state = _useState6[0],
      setState = _useState6[1];

  var callback = function callback(_ref, observer) {
    var _ref2 = _slicedToArray(_ref, 1),
        entry = _ref2[0];

    if (!ref || !entry || !observer) return;
    var isIntersecting = entry.isIntersecting;
    setState({
      isIntersecting: isIntersecting,
      entry: entry
    });

    if (isIntersecting) {
      onEnter && onEnter(entry, observer);
      if (unobserveOnEnter) observer.unobserve(ref);
    } else {
      onLeave && onLeave(entry, observer);
    }
  };

  useEffect(function () {
    if (!target) return;
    setRef(target.current);
  }, [target]);
  var observer = useObserver(ref, callback, {
    root: root,
    rootMargin: rootMargin,
    threshold: threshold
  }, externalState);
  return [setRef, state.isIntersecting, state.entry, observer];
};